import styled from 'styled-components'

import { MenuItemStyleProps, MenuItemStyles } from '../Menu/Menu'

const StyledMenuItem = styled.div.attrs({
  role: 'option',
})<MenuItemStyleProps>`
  ${MenuItemStyles};
  max-width: 100%;
  width: 100%;
  height: 100%;
`

export default StyledMenuItem
